interface LogoProps {
  className?: string;
}

export function CashLogo({ className = "w-full h-full" }: LogoProps) {
  return (
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      viewBox="0 0 50 50"
      className={className}
    >
      <path 
        fill="currentColor" 
        d="M21.8,28.4h-1.9c0,2,1.7,3.7,3.9,4.1v1.9h1.9v-1.9c2.3-.3,3.9-1.9,3.9-4.1s-1.6-3.8-3.9-4.1v-4.5c1.2.3,2,1.2,2,2.2h1.9c0-2-1.7-3.7-3.9-4.1v-1.8h-1.9v1.7c-2.3.3-3.9,1.9-3.9,4.1s1.5,3.8,3.9,4.1v4.5c-1.2-.3-2-1.2-2-2.2M25.7,26.2c1.1.2,2,.9,2,2.2s-1,2-2,2.2v-4.4h0ZM21.8,21.9c0-1.3,1-2,2-2.2v4.4c-1.1-.2-2-.9-2-2.2h0Z" 
      />
      <path 
        fill="currentColor" 
        d="M11.6,25.1c0,7.3,5.9,13.2,13.2,13.2s13.2-5.9,13.2-13.2-5.9-13.2-13.2-13.2h0c-7.3,0-13.2,5.9-13.2,13.2M24.8,13.8c6.2,0,11.3,5.1,11.3,11.3s-5.1,11.3-11.3,11.3-11.3-5.1-11.3-11.3,5.1-11.3,11.3-11.3" 
      />
      <path 
        fill="currentColor" 
        d="M24.7,42.9c-9.8,0-17.7-7.9-17.7-17.7s2.8-11.2,7.5-14.5l-.5,3.4,1.9.3.8-5.3c0-.5-.3-1-.8-1.1l-5.5-.8-.3,1.9,2.8.4c-8.7,6.5-10.4,18.8-3.9,27.4,5,6.7,13.7,9.5,21.7,6.9l-.6-1.8c-1.8.6-3.6.8-5.4.8" 
      />
      <path 
        fill="currentColor" 
        d="M44.8,24.8c0-10.8-8.8-19.6-19.6-19.6-2,0-4,.3-6,.9l.6,1.8c9.3-3,19.3,2.1,22.3,11.4,2.3,7.3-.3,15.3-6.5,19.8l.5-3.4-1.9-.3-.8,5.3c0,.5.3,1,.8,1.1l5.5.8.3-1.9-2.8-.4c4.8-3.7,7.7-9.4,7.7-15.5" 
      />
    </svg>
  );
}